// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M5 12H19%27 stroke=%27%233D70A1%27 stroke-width=%272%27 strokeLinecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M12 5V19%27 stroke=%27%23949494%27 stroke-width=%272%27 strokeLinecap=%27round%27 stroke-linejoin=%27round%27/%3E%3Cpath d=%27M5 12H19%27 stroke=%27%23949494%27 stroke-width=%272%27 strokeLinecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FrequentlyQuestion_faqContent__kN7sQ {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  column-gap: 0px;
  row-gap: 0px;
  /* max-width: 420px; */
}
.FrequentlyQuestion_faqContent__kN7sQ .FrequentlyQuestion_faqText__1GAWy {
  position: relative;
  /* &:last-child{
     & svg{
        top: 34px;
        @media (max-width: 767px) {
          top: 28px;
        }
      }
    } */
}
.FrequentlyQuestion_faqContent__kN7sQ .FrequentlyQuestion_faqText__1GAWy svg {
  position: absolute;
  top: 23px;
  right: 21px;
}
@media (max-width: 767px) {
  .FrequentlyQuestion_faqContent__kN7sQ .FrequentlyQuestion_faqText__1GAWy svg {
    top: 28px;
    right: 15px;
  }
}
.FrequentlyQuestion_faqContent__kN7sQ .is-open {
  position: relative;
}
.FrequentlyQuestion_faqContent__kN7sQ .is-open:after {
  position: absolute;
  content: "";
  height: 24px;
  width: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  right: 12px;
  top: 12px;
}
.FrequentlyQuestion_faqContent__kN7sQ .is-closed {
  position: relative;
}
.FrequentlyQuestion_faqContent__kN7sQ .is-closed:after {
  position: absolute;
  content: "";
  height: 24px;
  width: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  right: 12px;
  top: 12px;
}
.FrequentlyQuestion_faqContent__kN7sQ .Collapsible__trigger {
  /* composes: h1 from global; */
  display: block;
  margin-bottom: 0px;
  padding: 10px 64px 0px 18px;
  color: var(--black-shade-text-black, #272727);
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 42px; /* 233.333% */
  height: auto;
  display: flex;
  align-items: center;
  cursor: pointer;
}
@media (max-width: 1300px) {
  .FrequentlyQuestion_faqContent__kN7sQ .Collapsible__trigger {
    padding: 15px 48px 0px 18px;
  }
}
@media (max-width: 767px) {
  .FrequentlyQuestion_faqContent__kN7sQ .Collapsible__trigger {
    margin-bottom: 12px;
    padding: 15px 44px 0px 12px;
    height: 54px;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
  }
}
.FrequentlyQuestion_faqContent__kN7sQ .Collapsible {
  height: 100%;
}
.FrequentlyQuestion_faqContent__kN7sQ .Collapsible__contentInner {
  margin: 0 15px;
  padding: 16px 0 24px;
  color: var(--black-shade-para-text, #949494);
  font-size: 14px;
  font-style: normal;
  font-weight: 400px;
  line-height: normal;
  /* max-width: 365px; */
  border-bottom: 1px solid #dfdfdf;
}
@media (max-width: 767px) {
  .FrequentlyQuestion_faqContent__kN7sQ .Collapsible__contentInner {
    font-size: 14px;
    line-height: 20px;
  }
}

.FrequentlyQuestion_privacyPolicyWrapper__a6inW {
  min-height: 90vh;
  padding: 64px 0;
  max-width: 1000px;
  margin: 0 auto;
  margin-top: -50px;
}
.FrequentlyQuestion_privacyPolicyWrapper__a6inW .FrequentlyQuestion_title__VdoZq {
  margin-bottom: 20px;
  text-align: center;
  font-size: 40px;
}
@media (max-width: 767px) {
  .FrequentlyQuestion_privacyPolicyWrapper__a6inW .FrequentlyQuestion_title__VdoZq {
    font-size: 24px;
    margin-bottom: 20px;
  }
}
.FrequentlyQuestion_privacyPolicyWrapper__a6inW ul li {
  margin-bottom: 36px;
}
.FrequentlyQuestion_privacyPolicyWrapper__a6inW ul li p {
  margin-bottom: 16px;
}`, "",{"version":3,"sources":["webpack://./src/containers/LandingPage/FrequentlyQuestion.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,qCAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;AACJ;AAAI;EACE,kBAAA;EACA;;;;;;;OAAA;AASN;AADM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AAGR;AAFQ;EAJF;IAKI,SAAA;IACA,WAAA;EAKR;AACF;AAFI;EACE,kBAAA;AAIN;AAHM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,yDAAA;EACA,WAAA;EACA,SAAA;AAKR;AAFI;EACE,kBAAA;AAIN;AAHM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,yDAAA;EACA,WAAA;EACA,SAAA;AAKR;AAFI;EACE,8BAAA;EACA,cAAA;EACA,kBAAA;EACA,2BAAA;EACA,6CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAIN;AAHM;EAdF;IAeI,2BAAA;EAMN;AACF;AAJM;EAlBF;IAmBI,mBAAA;IACA,2BAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;IACA,aAAA;IACA,mBAAA;EAON;AACF;AALI;EACE,YAAA;AAON;AALI;EACE,cAAA;EACA,oBAAA;EACA,4CAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gCAAA;AAON;AANM;EAVF;IAWI,eAAA;IACA,iBAAA;EASN;AACF;;AANE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AASJ;AARI;EACI,mBAAA;EACA,kBAAA;EACA,eAAA;AAUR;AATQ;EAJJ;IAKQ,eAAA;IACA,mBAAA;EAYV;AACF;AATQ;EACI,mBAAA;AAWZ;AAVY;EACI,mBAAA;AAYhB","sourcesContent":[".faqContent {\r\n    display: grid;\r\n    grid-template-columns: repeat(1, 1fr);\r\n    column-gap: 0px;\r\n    row-gap: 0px;\r\n    /* max-width: 420px; */\r\n    & .faqText {\r\n      position: relative;\r\n      /* &:last-child{\r\n         & svg{\r\n            top: 34px;\r\n            @media (max-width: 767px) {\r\n              top: 28px;\r\n            }\r\n          }\r\n        } */\r\n      & svg {\r\n        position: absolute;\r\n        top: 23px;\r\n        right: 21px;\r\n        @media (max-width: 767px) {\r\n          top: 28px;\r\n          right: 15px;\r\n        }\r\n      }\r\n    }\r\n    & :global(.is-open) {\r\n      position: relative;\r\n      &:after {\r\n        position: absolute;\r\n        content: '';\r\n        height: 24px;\r\n        width: 24px;\r\n        background-image: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5 12H19' stroke='%233D70A1' stroke-width='2' strokeLinecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A\");\r\n        right: 12px;\r\n        top: 12px;\r\n      }\r\n    }\r\n    & :global(.is-closed) {\r\n      position: relative;\r\n      &:after {\r\n        position: absolute;\r\n        content: '';\r\n        height: 24px;\r\n        width: 24px;\r\n        background-image: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 5V19' stroke='%23949494' stroke-width='2' strokeLinecap='round' stroke-linejoin='round'/%3E%3Cpath d='M5 12H19' stroke='%23949494' stroke-width='2' strokeLinecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A\");\r\n        right: 12px;\r\n        top: 12px;\r\n      }\r\n    }\r\n    & :global(.Collapsible__trigger) {\r\n      /* composes: h1 from global; */\r\n      display: block;\r\n      margin-bottom: 0px;\r\n      padding: 10px 64px 0px 18px;\r\n      color: var(--black-shade-text-black, #272727);\r\n      font-size: 18px;\r\n      font-style: normal;\r\n      font-weight: 400;\r\n      line-height: 42px; /* 233.333% */\r\n      height: auto;\r\n      display: flex;\r\n      align-items: center;\r\n      cursor: pointer;\r\n      @media (max-width: 1300px) {\r\n        padding: 15px 48px 0px 18px;\r\n      }\r\n  \r\n      @media (max-width: 767px) {\r\n        margin-bottom: 12px;\r\n        padding: 15px 44px 0px 12px;\r\n        height: 54px;\r\n        font-size: 14px;\r\n        line-height: 20px;\r\n        display: flex;\r\n        align-items: center;\r\n      }\r\n    }\r\n    & :global(.Collapsible) {\r\n      height: 100%;\r\n    }\r\n    & :global(.Collapsible__contentInner) {\r\n      margin: 0 15px;\r\n      padding: 16px 0 24px;\r\n      color: var(--black-shade-para-text, #949494);\r\n      font-size: 14px;\r\n      font-style: normal;\r\n      font-weight: 400px;\r\n      line-height: normal;\r\n      /* max-width: 365px; */\r\n      border-bottom: 1px solid #dfdfdf;\r\n      @media (max-width: 767px) {\r\n        font-size: 14px;\r\n        line-height: 20px;\r\n      }\r\n    }\r\n  }\r\n  .privacyPolicyWrapper{\r\n    min-height: 90vh;\r\n    padding: 64px 0;\r\n    max-width: 1000px;\r\n    margin: 0 auto;\r\n    margin-top: -50px;\r\n    & .title{\r\n        margin-bottom: 20px;\r\n        text-align: center;\r\n        font-size: 40px;\r\n        @media (max-width: 767px) {\r\n            font-size: 24px;\r\n            margin-bottom: 20px;\r\n        }\r\n    }\r\n    & ul{\r\n        & li{\r\n            margin-bottom: 36px;\r\n            & p{\r\n                margin-bottom: 16px;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"faqContent": `FrequentlyQuestion_faqContent__kN7sQ`,
	"faqText": `FrequentlyQuestion_faqText__1GAWy`,
	"privacyPolicyWrapper": `FrequentlyQuestion_privacyPolicyWrapper__a6inW`,
	"title": `FrequentlyQuestion_title__VdoZq`
};
export default ___CSS_LOADER_EXPORT___;
